export enum ExportClientsCsvJobStatus {
    PENDING = 'pending',
    PROCESSING = 'processing',
    COMPLETED = 'completed',
    FAILED = 'failed',
}

export enum ExportClientsCsvJobType {
    MERGED_CLIENTS_CSV = 'merged_clients_csv',
}
